import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';

export function* fetchHelpContentSaga(action) {
  yield put(actions.fetchHelpContentStart(action.HelpType));
  try {
    const data = {};
    if (action.HelpType) {
      data.HelpType = action.HelpType;
    }
    const result = yield apiPost('help1_getHelp', data);
    const helpContent = result.data.payload;
    const helpCount = result.data.payload.HelpCount;
    delete helpContent.HelpCount;
    yield put(actions.fetchHelpContentSuccess(helpContent, helpCount));
  } catch (error) {
    yield put(actions.fetchHelpContentFailed(error.response.data.error_message));
  }
}

export default {};
